@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.BackButton {
  @extend %font-family-primary;

  align-items: center;
  color: $theme-filter-icon-color;
  display: inline-grid;
  font-weight: $font-weight-semibold;
  grid-template-columns: auto 1fr;
  font-size: 14px;

  a {
    color: $theme-color-text;
    text-decoration: none;
    // Overlap the SVG with the link to make the svg clickable
    padding-left: 1.25em;
    margin-left: -1em;

    &:hover,
    &:focus,
    &:active {
      text-decoration: underline;
    }
  }
}
